import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Sign } from '../_models/sign';
import { MockAuthService } from '../_services/_mocks/mockAuthService';

@Component({
  standalone: false,
  selector: 'app-destination-signature',
  templateUrl: './destination-signature.component.html',
  styleUrls: ['./destination-signature.component.scss']
})
export class DestinationSignatureComponent implements OnInit {
 // Objetos //
 currentSign;
  
 // Booleanos //
 signed: boolean = false;

 // Datos entre Componentes //
 @Input() signList: Array<Sign> = [];
 @Output() sendSign = new EventEmitter<object>();

 constructor(public mockAuthService: MockAuthService,
    private toastr: ToastrService,
   private modalService: NgbModal) { }
 
 ngOnInit(): void {}
 
 createSign(content, current) {
   this.signed = false;
   this.currentSign = current; //currentsign.type
   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
 }

 getSign(data: Sign){
   this.sendSign.emit(data)
 }

 showAlert(){
  this.toastr.warning('Please provide a consignee name first.');
  // alert('Please provide a consignee name first.');
 }
}
